import React from 'react'
import { NextPage } from 'next'
import { Box, Text } from '@chakra-ui/react'
import { Head, LinkRel } from 'src/components/common'
import { useHubspotForm } from '@aaronhayes/react-use-hubspot-form';

const ContattiPage: NextPage = () => {
  useHubspotForm({
    portalId: process.env.NEXT_PUBLIC_HUBSPOT_PORTAL_ID,
    formId: process.env.NEXT_PUBLIC_HUBSPOT_CONTACT_FORM_ID,
    target: '#contattaci-form'
  });

  return <Box bgColor="baseBackgroundLight" mt="m">
    <Box maxW="6xl" pt="0" pb="xxl" mx="auto" px="m">
      <Head title="Contattaci" />
      <LinkRel rel="canonical" href="https://www.carplanner.com/contatti" />

      <Text fontSize="1.75rem" fontFamily="Montserrat-SemiBold" color="baseDark" textAlign="left">
        Contattaci
      </Text>
      <Text textAlign="left">
        Compila il form con i tuoi dati per ricevere maggiori informazioni.<br />
        Un nostro consulente ti contatterà al più presto!
      </Text>
      <Box id="contattaci-form" mt="-1rem" fontFamily="Montserrat-Medium" textAlign="left" my="xxl" />

    </Box>
  </Box>
}

export default ContattiPage
